import React from 'react'

const Input = ({ value, placeholder }) => {
    return <input
        type="text"
        style={{
            height: "25px",
            fontSize: "13px",
            borderRadius: "5px 5px 5px 5px",
            opacity: 0.7,
            width: "100%",
        }}
        value={value}
        placeholder={placeholder}
        readOnly
    />
}

export default Input